import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const FlowHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding: 40px;
  background: white;
  border-bottom: 1px solid ${designTokens.colors.line.section};
`;

export const LeftGroup = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
`;

export const TitlePrompt = styled.span`
  /* "*플로우 제목을 입력해주세요" */
  color: ${designTokens.colors.font.tertiary};
  ${getTypography("korean", "title1")};
`;

export const HashTagList = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const HashTag = styled.span`
  /* "#음원분리" 등 */
  color: ${designTokens.colors.font.quaternary};
  ${getTypography("korean", "body3")};
`;

export const CopyButton = styled.button`
  /* "API 복사 ✦" */
  background: ${designTokens.colors.font.primary};
  color: ${designTokens.colors.background.primary};
  ${getTypography("korean", "body2")};
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
`;

export const TitleInput = styled.input`
  color: ${designTokens.colors.font.tertiary};
  ${getTypography("korean", "title1")};
  border: none;
  outline: none;
  background-color: transparent;
`;
